import Image from "next/image";
import type { FC } from "react";

import Skeleton from "@/components/global/SkeletonComponent/server/SkeletonComponent";

const SkeletonHomeSearchBarDesktopComponent: FC = () => {
  const length = 5;

  return (
    <div className="relative flex h-14 items-center justify-center rounded-b-none  bg-gradient-to-r from-gradientColorStops-red2-0 to-gradientColorStops-red2-100">
      <Image
        src="https://d31jk6ljx7wihh.cloudfront.net/images/search/panel-left.svg"
        alt="panel-left"
        width={0}
        height={0}
        className="absolute left-0 ml-[-114px] h-14 w-[114px]"
        priority
      />
      <div className="z-10 flex w-[643.8px] gap-[8px] md:mx-[-30px] lg:mx-[-40px]">
        {Array.from({ length }).map((_, index) => (
          <div key={index} className="flex w-full items-center gap-x-[0.45rem]">
            <Skeleton className="size-6 flex-none rounded-full" />
            <div className="flex h-6 w-full items-center">
              <Skeleton className="h-4 w-full" />
            </div>
          </div>
        ))}
      </div>
      <Image
        src="https://d31jk6ljx7wihh.cloudfront.net/images/search/panel-right.svg"
        alt="pattern-right"
        className="absolute right-0 mr-[-114px] h-14 w-[114px]"
        priority
        width={0}
        height={0}
      />
    </div>
  );
};

export default SkeletonHomeSearchBarDesktopComponent;
